import { Component, Prop, Vue } from 'vue-property-decorator'
import { BCol, BButton, BButtonGroup, BTooltip, VBTooltip } from 'bootstrap-vue'
import { VueConstructor } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import WidgetForm from '../WidgetForm/WidgetForm.vue'
import WidgetDelete from '../WidgetDelete/WidgetDelete.vue'
import WidgetNumber from '../WidgetNumber/WidgetNumber.vue'
import WidgetBar from '../WidgetBar/WidgetBar.vue'
import WidgetChronological from '../WidgetChronological/WidgetChronological.vue'
import WidgetChronologicalTable from '../WidgetChronologicalTable/WidgetChronologicalTable.vue'
import WidgetDiagram from '../WidgetDiagram/WidgetDiagram.vue'
import WidgetList from '../WidgetList/WidgetList.vue'
import { mapState } from 'vuex'

@Component({
  components: {
    WidgetForm, WidgetDelete,
    BCol, BButton, BButtonGroup, BTooltip,
    FontAwesomeIcon
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  computed: {
    ...mapState('globalDatas', ['teamUsers'])
  }
})
export default class Widget extends Vue {
  teamUsers!: KwixeoFramework.TeamUsers

  @Prop({ required: true }) value!: KwixeoDashboard.Widget
  @Prop({ required: true }) datas!: KwixeoDashboard.DashboardDatas
  @Prop({ required: true }) editionMode!: boolean
  @Prop({ required: true }) filters!: KwixeoInterface.GenericObject
  @Prop({ required: true }) initialized!: boolean

  private edit = false
  private deleting = false
  get component (): VueConstructor|void {
    switch (this.value.type) {
      case 'number':
        return WidgetNumber
      case 'bar':
        return WidgetBar
      case 'diagram':
        return WidgetDiagram
      case 'chronological':
        return WidgetChronological
      case 'list':
        return WidgetList
      case 'chronological-table':
        return WidgetChronologicalTable
    }
  }

  get computedTeamUsers (): KwixeoFramework.TeamUsers {
    const teamUserIds: number[] = (this.value.params?.filters?.team_users as number[]) ?? []
    const teamUsers: (KwixeoFramework.TeamUser|undefined)[] = teamUserIds.map((id: number) => this.teamUsers.find(user => user.id === Number(id)))
    return teamUsers.filter(user => user !== undefined) as KwixeoFramework.TeamUsers
  }

  get computedPeriodFilter (): string|null {
    let text: string
    switch (this.value.params.period) {
      case 'year':
        return this.$t('dashboard.widget.currentYear') as string
      case 'month':
        return this.$t('dashboard.widget.currentMonth') as string
      case 'week':
        return this.$t('dashboard.widget.currentWeek') as string
      case 'day':
        return this.$t('dashboard.widget.currentDay') as string
      case 'custom':
        text = String(this.value.params.period_value)
        switch (this.value.params.period_type) {
          case 'month':
            text += this.$t('dashboard.widget.lastMonths') as string
            break
          case 'week':
            text += this.$t('dashboard.widget.lastWeeks') as string
            break
          case 'day':
            text += this.$t('dashboard.widget.lastDays') as string
            break
        }
        return text
      default:
        return null
    }
  }
}
